import React from 'react';
import { useLanguage } from '../../../../../../contexts/LanguageContext';
import '../../../../dealerApproval/dealerApproval.scss';

/**
 * Sekme başlığı değişiklik rozeti.
 * tabChange = { insertCount, updateCount, deleteCount, closeOutCount, totalCount } | null
 */
const TabChangeBadge = ({ tabChange }) => {
    const { th } = useLanguage();

    if (!tabChange || !(tabChange.totalCount > 0)) return null;

    return <span className="dealer-tab-change-badge">{th('dealerApproval.tab.updated')}</span>;
};

export default TabChangeBadge;
